// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import Checkbox from '../controls/Checkbox'
import styled from 'styled-components'
import ErrorText from '../controls/ErrorText'

const Providers = styled.div`
  margin-top: 4px;
`

const ProviderLine = styled.div`
  padding-bottom: 12px;
`

type Props = {|
  providers: Array<string>,
  providersInfo: Array<{ id: string, name: string, disabled?: boolean }>,
  errors: Array<string>,
  hide?: boolean,
  onChange: Function
|}

export default class ProvidersSet extends Component<Props> {
  render() {
    if (this.props.hide) return null

    return (
      <div>
        <Providers className="ort-providers">
          {this.props.providersInfo.map((providerInfo) => (
            <ProviderLine
              className="t-ProvidersSet__line"
              data-provider={providerInfo.id}
              key={providerInfo.id}
            >
              <Checkbox
                onChange={(checked) => this.onCheckedChange(providerInfo.id, checked)}
                checked={
                  !providerInfo.disabled && _.includes(this.availableProviders(), providerInfo.id)
                }
                disabled={providerInfo.disabled}
                label={providerInfo.name}
              />
            </ProviderLine>
          ))}
        </Providers>
        <ErrorText errors={this.props.errors} />
      </div>
    )
  }

  availableProviders(): Array<string> {
    return _.filter(this.props.providers, (p) => {
      const singleProviderInfo = _.find(this.props.providersInfo, { id: p })
      return singleProviderInfo && !singleProviderInfo.disabled
    })
  }

  onCheckedChange(provider: string, isChecked: boolean) {
    let providers = this.availableProviders()
    if (isChecked) {
      providers = _.sortBy(_.uniq(_.concat(providers, provider)))
    } else {
      providers = _.reject(providers, (item) => item === provider)
    }
    this.props.onChange && this.props.onChange(providers)
  }
}
